import React, { createContext, useState } from "react";

export const IgChatContext = createContext();

export const IgChatContextProvider = ({ children }) => {
  // Daftar akun IG dari ig-adapter GET /accounts
  const [accountList, setAccountList] = useState([]);
  // Akun yang sedang dipilih di dropdown: { slug, name }
  const [selectedAccount, setSelectedAccount] = useState(null);
  // Daftar conversation dari ig-adapter GET /chats
  const [chatList, setChatList] = useState([]);
  // Conversation yang sedang dibuka (object ChatResponse lengkap)
  const [selectedChat, setSelectedChat] = useState(null);
  // conversation_id dari conversation yang sedang dibuka
  const [selectedId, setSelectedId] = useState(null);
  // Map department_id → { id, name, color } untuk lookup badge warna
  const [departmentMap, setDepartmentMap] = useState({});

  return (
    <IgChatContext.Provider
      value={{
        accountListState: [accountList, setAccountList],
        selectedAccountState: [selectedAccount, setSelectedAccount],
        chatListState: [chatList, setChatList],
        selectedChatState: [selectedChat, setSelectedChat],
        selectedIdState: [selectedId, setSelectedId],
        departmentMapState: [departmentMap, setDepartmentMap],
      }}
    >
      {children}
    </IgChatContext.Provider>
  );
};
